import React from 'react';

type StatusTone = 'neutral' | 'success' | 'warning' | 'danger';

type StatusPillProps = {
  label: string;
  tone?: StatusTone;
  className?: string;
};

const toneStyles: Record<StatusTone, React.CSSProperties> = {
  neutral: { color: 'var(--color-text)', borderColor: 'var(--color-border)' },
  success: { color: 'var(--color-success)', borderColor: 'var(--color-success)' },
  warning: { color: 'var(--color-warning)', borderColor: 'var(--color-warning)' },
  danger: { color: 'var(--color-danger)', borderColor: 'var(--color-danger)' },
};

const StatusPill: React.FC<StatusPillProps> = ({ label, tone = 'neutral', className }) => {
  return (
    <span
      className={className || ''}
      style={{
        ...toneStyles[tone],
        display: 'inline-flex',
        alignItems: 'center',
        borderWidth: 1,
        borderStyle: 'solid',
        borderRadius: 999,
        padding: '4px 12px',
        fontSize: '0.7rem',
        fontWeight: 600,
        letterSpacing: '0.08em',
        textTransform: 'uppercase',
      }}
    >
      {label}
    </span>
  );
};

export default StatusPill;
